// @flow

import './index.scss';
import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import Link from 'components/Link';

const Bottom = (): React.Node => {
    const { __ } = useTranslate();

    return (
        <div className="Bottom">
            <div className="Bottom__body">
                <p>
                    <span className="Bottom__part1">
                        {__('footer:ad-part1')}
                    </span>
                    <br />
                    <span className="Bottom__part2">
                        {__('footer:ad-part2')}
                    </span>
                </p>
                <Link className="Bottom__button" to="/publish">
                    {__('footer:ad-button')}
                </Link>
            </div>
        </div>
    );
};

export default Bottom;
